import React from 'react';
import './Footer.css';
import { menu, socialHandles } from '../../data';
import { Link } from 'react-scroll';

const Footer = () => {
  return (
    <footer id="footer">
      <div className='footer__container'>
      <div className="section__wrapper">
        <ul className="nav__link__container">
          {menu.map((list, index) => (
            <Link
              activeClass="active"
              className="tab__item name"
              to={list.name.toLowerCase()}
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              key={index}
            >
              {list.name}
            </Link>
          ))}
        </ul>
      </div>

      <div className="social__handles__container">
        {socialHandles.map((list, index) => {
          return (
            <a
              href={list.link}
              className="icon__container social__handles"
              target="_blank"
              rel="noopener noreferrer"
              key={index}
            >
              {list.icon}
            </a>
          );
        })}
      </div>

      <div className="conpyright__container">
        <h3>Copyright &copy; All rights reserved - | 2024</h3>
        <p className="text__muted">Built with love by Yassin Al Farwan</p>
      </div>
      </div>
    </footer>
  );
};

export default Footer;